export const SET_REDIRECT_ROUTE = "SET_REDIRECT_ROUTE";
export const RESET_REDIRECT_ROUTE = "RESET_REDIRECT_ROUTE";